import { NavLink } from 'react-router-dom';
import navMenuLogos from '../../utils/constants/navMenuLogos';

/**
 * getNavMenuItems function.
 * @function
 * @param {Object} routes - The routes object.
 * @param {Object} subRoutes - The sub routes object.
 * @param {Object} pathSearches - The path searches object.
 * @param {string} path - The path string.
 * @param {Function} t - The translation function.
 * @returns {Array} - The array of nav menu items.
 */
export const getNavMenuItems = (routes, subRoutes, pathSearches, path, t) =>
  Object.entries(routes).map(([menuItem, p]) =>
    subRoutes[menuItem]
      ? {
          key: p,
          icon: navMenuLogos[menuItem],
          label: t(`basiclayout.menu.${menuItem.toLowerCase()}`),
          children: Object.entries(subRoutes[menuItem]).map(
            ([subMenuItem, subPath]) => ({
              key: subPath,
              disabled: subPath === '',
              label: (
                <NavLink
                  to={`${p}${subPath}${
                    pathSearches[subMenuItem] ? pathSearches[subMenuItem] : ''
                  }`}
                >
                  <span>
                    {t(`basiclayout.submenu.${subMenuItem.toLowerCase()}`)}
                  </span>
                </NavLink>
              )
            })
          )
        }
      : {
          key: p,
          disabled: p === '',
          label: (
            <NavLink
              to={`${p}${pathSearches[menuItem] ? pathSearches[menuItem] : ''}`}
            >
              {navMenuLogos[menuItem]}
              <span>{t(`basiclayout.menu.${menuItem.toLowerCase()}`)}</span>
            </NavLink>
          )
        }
  );
